/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initialState = {
  performResolutionObj: {},
  planType: [],
  rebateProgram: [],

  rebateProgram: [],
  rebateProgramName: {},
  errorMsgTopBalances: [],
  from: '',
  to: '',
  quarterRange: 'All',
  credit: '0',
  dramsInvoice: '',
  firstSummary: '',
  creditMfg: '',
  debitMfg: '',
  dramsData: '',
  firstSummaryData: '',
  exportAllData: [],
  selectedDisplayValue: null,
  selectedManufactureValue: {},
  balanceDue: [],
  creditDebit: [],

  displayObj: {
    rebateProgramName: {},
    from: '',
    to: '',
    quarterRange: 'All',
    creditDebit: [],
    selectedDisplayValue: null,
    balanceDue: [],
    credit: '0',
    dramsData: '',
    firstSummaryData: '',
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_BALANCES:
      return { ...state, performResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_BALANCES:
      return { ...state, resolutionDetailObj: action.detailScrData };
    case actionTypes.GET_ERROR_MSG_TOP_BALANCES:
      return { ...state, errorMsgTopBalances: action.payload };

    case actionTypes.GET_PLAN_TYPE_DATA_BALANCES:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_BALANCES:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_BALANCES:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.DISPLAY_QUARTER_RANGE:
      return { ...state, quarterRange: action.payload };
    case actionTypes.SET_DISPLAY_OBJ_BALANCES:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_CREDIT_DEBIT:
      let displayObj = {
        ...state.displayObj,
        creditDebit: action.payload,
      };
      return { ...state, creditDebit: action.payload, displayObj };

    case actionTypes.DISPLAY_MANUFACTURE_NO:
      return { ...state, selectedDisplayValue: action.payload };
    case actionTypes.SET_MANUFACTURE_NO:
      return { ...state, selectedManufactureValue: action.payload };
    case actionTypes.GET_BALANCE_DUE:
      let displayObj1 = {
        ...state.displayObj,
        balanceDue: action.payload,
      };
      return { ...state, balanceDue: action.payload, displayObj: displayObj1 };
    case actionTypes.DISP_DETAIL_TOP_BAL_DATA:
      return { ...state, detailBalanceDue: action.payload };
    case actionTypes.GET_FROM_BALANCES:
      return { ...state, from: action.payload };
    case actionTypes.GET_TO_BALANCES:
      return { ...state, to: action.payload };
    case actionTypes.SET_CREDIT_DEBIT_OPTION:
      return { ...state, credit: action.payload };
    case actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE:
      return { ...state, dramsInvoice: action.payload };

    case actionTypes.GET_FIRST_SUMMARY_REPORT_OPTION:
      return { ...state, firstSummary: action.payload };
    case actionTypes.GET_CREDIT_MFG_BALANCES:
      return { ...state, creditMfg: action.payload };
    case actionTypes.GET_DEBIT_MFG_BALANCES:
      return { ...state, debitMfg: action.payload };
    case actionTypes.GET_DATE_RANGE:
      return { ...state, ...action.payload };
    case actionTypes.SET_PAGINATION_INDEX_TO_BALANCE:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };
    case actionTypes.SET_REFRESH_DATA_BALANCES:
      return {
        ...state,
        performResolutionObj: {},
        planType: [],
        rebateProgram: [],

        rebateProgram: [],
        rebateProgramName: {},
        errorMsgTopBalances: [],
        from: '',
        to: '',
        quarterRange: 'All',
        credit: '0',
        dramsInvoice: '',
        firstSummary: '',
        creditMfg: '',
        debitMfg: '',
        dramsData: '',
        firstSummaryData: '',
        exportAllData: [],
        selectedDisplayValue: null,
        selectedManufactureValue: {},
        balanceDue: [],
        creditDebit: [],
      };
    case actionTypes.SET_REFRESH_DATA_BALANCES_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    case actionTypes.SET_EXPORT_ALL_TOP_BALANCES:
      return {
        ...state,
        exportAllData: action.payload,
      };

    default:
      return state;
  }
};
export default reducer;
